import axios from "axios";
import { Payout_Service } from "../Url";


export const payoutRegenerateHistoryAction = {
  PAYOUT_REGENERATE_HISTORY_SUCCESS: "PAYOUT_REGENERATE_HISTORY_SUCCESS",
    PAYOUT_REGENERATE_HISTORY_ERROR: "PAYOUT_REGENERATE_HISTORY_ERROR", 
};


export function payoutRegenerateHistorySuccess(props) {
  const { accessToken, financialYear, page, record } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/get/history/${financialYear}?page=${page}&records=${record}`,
        // url: `http://localhost:8301/partner-payout-service/reports/get/history/${financialYear}?page=${page}&records=${record}`,
      });
      const data = response.data;
      dispatch({
        type: payoutRegenerateHistoryAction.PAYOUT_REGENERATE_HISTORY_SUCCESS,
        payload: data.data,
      });
      console.log("Payout Regenerate History:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: payoutRegenerateHistoryAction.PAYOUT_REGENERATE_HISTORY_ERROR,
        payload: error.message || "Failed to fetch payout regenerate history",
      });
      return error;
    }
  };
}